import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import { Grid, Skeleton, Typography } from "@mui/material";
import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import MuiAccordionSummary, {
  AccordionSummaryProps,
} from "@mui/material/AccordionSummary";
import { styled } from "@mui/material/styles";
import React from "react";
import TableRowSkeleton from "../../../components/skeletons/TableRowSkeleton";

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={
      <ArrowDropDownIcon sx={{ fontSize: "2rem", color: "#1D4A87" }} />
    }
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === "dark"
      ? "rgba(255, 255, 255, .05)"
      : "rgba(0, 0, 0, .03)",
  flexDirection: "row-reverse",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
  },
  "& .MuiAccordionSummary-content": {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: "1px solid rgba(0, 0, 0, .125)",
}));

const AccordionSkeleton = () => {
  return (
    <>
      <Grid item xs={12} sx={{ height: "73vh", overflowY: "auto" }}>
        {[...Array(3)]?.map((x, index) => (
          <Accordion defaultExpanded={index === 0}>
            <AccordionSummary
              aria-controls={`panel${index + 1}d-content`}
              id={`panel${index + 1}d-header`}
              sx={{ background: index % 2 === 0 ? "#fff" : "" }}
            >
              <Grid
                container
                sx={{ justifyContent: "space-between !important" }}
              >
                <Grid item>
                  <Typography
                    sx={{
                      marginRight: "1.5rem",
                      fontWeight: "bold",
                      color: "#1D4A87",
                    }}
                  >
                    <Skeleton width={150} height={30} variant="rectangular" />
                  </Typography>
                </Grid>
                <Grid item>
                  <Grid container gap={"7px"}>
                    <Grid item>
                      <AddCircleOutlineIcon
                        sx={{
                          color: "#9AAFC4",
                          "&: hover": { color: "#1D4A87" },
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <ModeEditOutlinedIcon
                        sx={{
                          color: "#9AAFC4",
                          "&: hover": { color: "#1D4A87" },
                        }}
                      />
                    </Grid>
                    <Grid item>
                      <DeleteOutlineOutlinedIcon sx={{ color: "#9AAFC4" }} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </AccordionSummary>
            {
              <AccordionDetails>
                <Typography className="userReport-list">
                  <TableRowSkeleton rowsNum={5} columnsNum={10} width={120} />
                </Typography>
              </AccordionDetails>
            }
          </Accordion>
        ))}
      </Grid>
    </>
  );
};

export default AccordionSkeleton;
